"use client";

/**
 * lesson-card-motion.tsx — 课卡的动效叶子(客户端)
 *
 * 课库页是服务端组件(SSR 筛选/分页不可动),交互与动效全部隔离在这片叶子里:
 * 滚动进入视口时轻落定 + 悬停时牌卡被指尖挑起。只动 transform / opacity,
 * prefers-reduced-motion 全部塌缩为静态。
 */

import { motion, useReducedMotion } from "motion/react";
import { DOJO_EASE } from "./dojo";

export function LessonCardMotion({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-24px" }}
      whileHover={reduce ? undefined : { y: -4 }}
      transition={
        reduce ? { duration: 0.15 } : { duration: 0.45, ease: DOJO_EASE }
      }
    >
      {children}
    </motion.div>
  );
}
